import { type ReactNode, useEffect, useState } from 'react';
import { appConfig } from '../config';
import { AccessDenied } from '../pages/AccessDenied';

type SessionState = {
  authenticated: boolean;
  email?: string;
};

export function ProtectedRoute({ children }: { children: (username: string) => ReactNode }): JSX.Element {
  const [session, setSession] = useState<SessionState>();

  useEffect(() => {
    void fetch('/auth/me', { credentials: 'same-origin', cache: 'no-store' })
      .then(async (response) => {
        if (!response.ok) throw new Error(`Session endpoint ${response.status}`);
        return (await response.json()) as SessionState;
      })
      .then((value) => {
        if (!value.authenticated) {
          window.location.assign('/auth/login?returnUrl=/');
          return;
        }
        setSession(value);
      })
      .catch(() => window.location.assign('/auth/login?returnUrl=/'));
  }, []);

  if (!session?.authenticated || !session.email) {
    return (
      <div className="flex min-h-screen items-center justify-center text-slate-400">
        Signing in with Microsoft 365...
      </div>
    );
  }

  if (session.email.toLowerCase() !== appConfig.allowedUser.toLowerCase()) {
    return <AccessDenied attemptedUser={session.email} />;
  }

  return <>{children(session.email)}</>;
}
